import React from 'react';
import { withRouter } from 'react-router-dom';

class RouteChangeWrapper extends React.Component {
  render() {
    return this.props.children;
  }
}

export default withRouter(RouteChangeWrapper);
